/** Keep Shopify's selected variant, price, stock and planning link together. */
class LoraProductJourney extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = {signal:this.controller.signal};
    this.select = this.querySelector('[data-product-variant]');
    this.select.addEventListener('change', () => this.updateVariant(), options);
    this.updateConsultation();
    this.addEventListener('click', event => {
      const thumbnail = event.target.closest('[data-product-image]');
      if (!thumbnail) return;
      event.preventDefault();
      this.showImage(thumbnail);
    }, options);
  }
  disconnectedCallback() { this.controller?.abort();this.controller=null; }
  showImage(thumbnail) {
    const image=this.querySelector('[data-product-main-image]');
    if (!image) return;
    image.src=thumbnail.href;
    image.srcset=thumbnail.dataset.srcset || '';
    image.alt=thumbnail.dataset.alt || '';
    this.querySelector('[data-product-zoom]').href=thumbnail.href;
    for (const item of this.querySelectorAll('[data-product-image]')) item.setAttribute('aria-current',String(item===thumbnail));
  }
  // Build contact context without resetting quantity or rewriting the landing URL.
  updateConsultation() {
    const option = this.select?.selectedOptions[0];
    const whatsapp = this.querySelector('[data-product-consult]');
    if (!option || !whatsapp) return;
    const page = new URL(location.href);
    page.searchParams.set('variant', option.value);
    const variantLabel = this.dataset.defaultVariant === 'true' ? '' : option.textContent.trim();
    const message = [this.dataset.message, this.dataset.productTitle, variantLabel, page.href].filter(Boolean).join('\n');
    const wa = new URL('https://wa.me/972509445045');
    wa.searchParams.set('text', message);
    whatsapp.href = wa.href;
  }
  updateVariant() {
    const option=this.select.selectedOptions[0];
    if (!option) return;
    this.querySelector('[data-product-price]').textContent=option.dataset.priceText;
    const previous=this.querySelector('[data-product-compare]');
    previous.textContent=option.dataset.compareText || '';
    previous.hidden=!option.dataset.compareText;
    const available=option.dataset.available==='true';
    const button=this.querySelector('[data-product-add]');
    button.disabled=!available;
    button.textContent=available?this.dataset.addLabel:this.dataset.soldLabel;
    this.querySelector('[data-product-stock]').textContent=available?this.dataset.stockLabel:this.dataset.soldLabel;
    const quantity=this.querySelector('[name="quantity"]');
    quantity.min=option.dataset.min;
    quantity.step=option.dataset.increment;
    if (option.dataset.max) quantity.max=option.dataset.max;
    else quantity.removeAttribute('max');
    quantity.value=option.dataset.min;
    for (const planner of this.querySelectorAll('[data-product-planner]')) { const url=new URL(planner.href);url.searchParams.set('variant',option.value);planner.href=url.href; }
    const page=new URL(location.href);page.searchParams.set('variant',option.value);history.replaceState(null,'',page);
    this.updateConsultation();
    const imageId=option.dataset.image;
    if (imageId) { const thumbnail=[...this.querySelectorAll('[data-product-image]')].find(item=>item.dataset.imageId===imageId);if(thumbnail)this.showImage(thumbnail); }
    this.querySelector('[data-product-announcement]').textContent=`${option.textContent.trim()} · ${option.dataset.priceText}`;
  }
}
if (!customElements.get('lora-product-journey')) customElements.define('lora-product-journey',LoraProductJourney);
